class FullWidthSlider {
  constructor(section) {
    this.section = section;
    this.sliderElement = section.querySelector("[data-slider-track]");

    if (!this.sliderElement) return;

    this.init();
  }

  init() {
    this.splide = new Splide(this.sliderElement, {
      type: "loop",
      fixedWidth: "282px",
      focus: "center",
      gap: "67px",
      pagination: false,
      arrows: false,
      drag: true,
      autoScroll: {
        speed: 0.5,
        pauseOnHover: true,
        pauseOnFocus: true,
      },
      breakpoints: {
        1024: {
          fixedWidth: "180px",
          gap: "40px",
        },
        767: {
          fixedWidth: "160px",
          gap: "30px",
        },
      },
    });

    this.splide.mount(window.splide?.Extensions);
  }

  destroy() {
    if (this.splide) {
      this.splide.destroy();
    }
  }
}

const initFullWidthSliders = (root = document) => {
  root
    .querySelectorAll(".full-width-slider[data-slider]")
    .forEach((section) => {
      if (section.__fullWidthSlider) {
        section.__fullWidthSlider.destroy();
      }
      section.__fullWidthSlider = new FullWidthSlider(section);
    });
};

document.addEventListener("DOMContentLoaded", () => {
  initFullWidthSliders();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    initFullWidthSliders(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target.querySelector(
      ".full-width-slider[data-slider]"
    );
    if (section && section.__fullWidthSlider) {
      section.__fullWidthSlider.destroy();
      section.__fullWidthSlider = null;
    }
  });
}
